import "./Agents.scss";

import ButtonPrimary from "../../components/shared/ButtonPrimary";

import Feature_1_1 from "../../assets/images/agents/feature-1-1.svg";
import Feature_1_2 from "../../assets/images/agents/feature-1-2.svg";
import Feature_1_3 from "../../assets/images/agents/feature-1-3.svg";
import Feature_1_4 from "../../assets/images/agents/feature-1-4.svg";
import Feature_2_1 from "../../assets/images/agents/feature-2-1.svg";
import Feature_2_2 from "../../assets/images/agents/feature-2-2.svg";
import Feature_2_3 from "../../assets/images/agents/feature-2-3.svg";
import Feature_3_1 from "../../assets/images/agents/feature-3-1.svg";
import Feature_3_2 from "../../assets/images/agents/feature-3-2.svg";
import Feature_3_3 from "../../assets/images/agents/feature-3-3.svg";
import Feature_4_1 from "../../assets/images/agents/feature-4-1.svg";
import Feature_4_2 from "../../assets/images/agents/feature-4-2.svg";
import Feature_4_3 from "../../assets/images/agents/feature-4-3.svg";
import Feature_5_1 from "../../assets/images/agents/feature-5-1.svg";
import Feature_5_2 from "../../assets/images/agents/feature-5-2.svg";
import Feature_5_3 from "../../assets/images/agents/feature-5-3.svg";
import Feature_6_1 from "../../assets/images/agents/feature-6-1.svg";
import Feature_6_2 from "../../assets/images/agents/feature-6-2.svg";
import Feature_6_3 from "../../assets/images/agents/feature-6-3.svg";
import Feature_7_1 from "../../assets/images/agents/feature-7-1.svg";
import Feature_7_2 from "../../assets/images/agents/feature-7-2.svg";
import Feature_7_3 from "../../assets/images/agents/feature-7-3.svg";

import Agent1 from "../../assets/images/agents/agent-1.png";
import Agent2 from "../../assets/images/agents/agent-2.png";
import Agent3 from "../../assets/images/agents/agent-3.png";
import Agent4 from "../../assets/images/agents/agent-4.png";
import Agent5 from "../../assets/images/agents/agent-5.png";
import Agent6 from "../../assets/images/agents/agent-6.png";
import Agent7 from "../../assets/images/agents/agent-7.png";

import Decoration2Img from "../../assets/images/deocration/decoration-2.png";
import Decoration3Img from "../../assets/images/deocration/decoration-3.png";
import Decoration4Img from "../../assets/images/deocration/decoration-4.png";
import React from "react";

const agentData = [
	{
		title: "Codex - Your Smart Website Architect",
		description:
			"AI-powered web designer that builds fully functional, Web3-ready websites effortlessly.",
		buttonText: "Launch Your Website",
		link: "https://vernusai.gitbook.io/vernusai/meet-our-autonomous-agents/codex-your-smart-website-architect",
		abilities: [
			{
				icon: Feature_1_1,
				title: "Automated site creation",
				description: "No coding required",
			},
			{
				icon: Feature_1_2,
				title: "Customizable designs",
				description: "Tailored for blockchain projects",
			},
			{
				icon: Feature_1_3,
				title: "Seamless smart contract & API integration",
				description: null,
			},
			{
				icon: Feature_1_4,
				title: "Continuous optimization",
				description: "For performance & security",
			},
		],
		images: [
			{
				src: Agent1,
				alt: "Agent 1",
				className: "agent",
			},
		],
		decorationImage: null,
	},
	{
		title: "Sketchy - Your AI Logo Designer",
		description:
			"Create stunning, professional logos in seconds—no design skills needed.",
		buttonText: "Design Your Logo Now",
		link: "https://vernusai.gitbook.io/vernusai/sketchy-your-ai-logo-designer",
		abilities: [
			{
				icon: Feature_2_1,
				title: "Instant AI-generated logos",
				description: "customized to your brand",
			},
			{
				icon: Feature_2_2,
				title: "Editable & scalable designs",
				description: "for web, print, & blockchain",
			},
			{
				icon: Feature_2_3,
				title: "Multiple styles & iterations",
				description: "for perfect branding",
			},
		],
		images: [
			{
				src: Agent2,
				alt: "Agent 2",
				className: "agent",
			},
		],
		decorationImage: {
			src: Decoration2Img,
			alt: "Decoration",
			className: "agents-decoration-1 decoration",
		},
	},
	{
		title: "Doc - Your AI White Paper Architect",
		description:
			"Turn ideas into professionally crafted white papers with ease.",
		buttonText: "Start Your White Paper",
		link: "https://vernusai.gitbook.io/vernusai/doc-your-ai-white-paper-architect",
		abilities: [
			{
				icon: Feature_3_1,
				title: "Automated white paper creation",
				description: "Just input your details",
			},
			{
				icon: Feature_3_2,
				title: "Customizable templates",
				description: "Structured & visually engaging",
			},
			{
				icon: Feature_3_3,
				title: "Real-time AI editing & optimization",
				description: null,
			},
		],
		images: [
			{
				src: Agent3,
				alt: "Agent 3",
				className: "agent",
			},
		],
		decorationImage: null,
	},
	{
		title: "Oracle - Your Strategic Market Predictor",
		description:
			"Stay ahead with AI-driven market predictions and real-time insights.",
		buttonText: "Analyze Market Trends",
		link: "https://vernusai.gitbook.io/vernusai/oracle-your-strategic-partner-for-accurate-market-predictions",
		abilities: [
			{
				icon: Feature_4_1,
				title: "Trend forecasting",
				description: "crypto & Web3 market analysis",
			},
			{
				icon: Feature_4_2,
				title: "Sentiment tracking",
				description: "Understand community opinions",
			},
			{
				icon: Feature_4_3,
				title: "Automated risk alerts & investment insights",
				description: null,
			},
		],
		images: [
			{
				src: Agent4,
				alt: "Agent 4",
				className: "agent",
			},
		],
		decorationImage: {
			src: Decoration3Img,
			alt: "Decoration",
			className: "agents-decoration-2 decoration",
		},
	},
	{
		title: "Blockster - No-Code Smart Contract Builder",
		description:
			"Build, audit, and deploy secure blockchain contracts—without coding.",
		buttonText: "Build Smart Contract",
		link: "https://vernusai.gitbook.io/vernusai/blockster-building-blockchain-contracts-no-code-needed",
		abilities: [
			{
				icon: Feature_5_1,
				title: "Automated smart contract creation for any blockchain project",
				description: null,
			},
			{
				icon: Feature_5_2,
				title: "Security audits & gas fee optimization",
				description: null,
			},
			{
				icon: Feature_5_3,
				title: "No coding required",
				description: "Accessible for non-developers",
			},
		],
		images: [
			{
				src: Agent5,
				alt: "Agent 5",
				className: "agent",
			},
		],
		decorationImage: null,
	},
	{
		title: "Chatty - Your 24/7 Virtual AI Assistant",
		description:
			"An intelligent, always-online chatbot for customer support & engagement.",
		buttonText: "Integrate Chatty Now",
		link: "https://vernusai.gitbook.io/vernusai/chatty-your-24-7-virtual-assistant",
		abilities: [
			{
				icon: Feature_6_1,
				title: "Instant customer support",
				description: null,
			},
			{
				icon: Feature_6_2,
				title: "Automated user guidance",
				description: null,
			},
			{
				icon: Feature_6_3,
				title: "Lead generation & community engagement",
				description: null,
			},
		],
		images: [
			{
				src: Agent6,
				alt: "Agent 6",
				className: "agent",
			},
		],
		decorationImage: {
			src: Decoration4Img,
			alt: "Decoration",
			className: "agents-decoration-3 decoration",
		},
	},
	{
		title: "Trackster - Secure, Real-Time Wallet Tracking",
		description:
			"Monitor your crypto wallets with real-time notifications & security alerts.",
		buttonText: "Track Your Wallet",
		link: "https://vernusai.gitbook.io/vernusai/trackster-secure-real-time-wallet-tracking",
		abilities: [
			{
				icon: Feature_7_1,
				title: "Instant transaction updates & alerts",
				description: null,
			},
			{
				icon: Feature_7_2,
				title: "Multi-wallet tracking",
				description: "Manage all assets in one place",
			},
			{
				icon: Feature_7_3,
				title: "Suspicious activity monitoring",
				description: "for ultimate security",
			},
		],
		images: [
			{
				src: Agent7,
				alt: "Agent 7",
				className: "agent",
			},
		],
		decorationImage: null,
	},
];

export default function Agents() {
	return (
		<>
			<div className="agents">
				<div className="agents-content-wrapper content-wrapper-lg">
					<div className="agents-content">
						<h3 className="agents-title" data-aos="fade-up">
							<span className="title-txt">
								Meet Our Autonomous Agents
							</span>
						</h3>

						<p className="agents-desc" data-aos="fade-up" data-aos-delay="100">
							Our {agentData.length} specialized AI agents are
							built to simplify Web3 development, each designed to
							cater to specific needs:
						</p>
					</div>

					<div className="agents-list">
						{/* Map through agent data to dynamically generate agents */}
						{agentData.map((agent, index) => (
							<React.Fragment key={index}>
								{/* Render decoration image if it exists */}
								{agent.decorationImage && (
									<div
										className={
											agent.decorationImage.className
										}
									>
										<img
											src={agent.decorationImage.src}
											alt={
												agent.decorationImage.alt ||
												"Decoration"
											}
										/>
									</div>
								)}
								
								<div
									className={`agent-item ${
										index % 2 !== 0 ? "rtl" : ""
									}`}
									data-aos="zoom-in"
								>
									<div className="agent-item-inner">
										<div className="agent-item-content">
											<div className="agent-title">
												{agent.title}
											</div>
											<p className="agent-desc">
												{agent.description}
											</p>

											<div className="agent-btns">
												<ButtonPrimary className="agent-item-btn" href={agent.link}>
													{agent.buttonText}
												</ButtonPrimary>
											</div>
										</div>

										<div className="agent-image">
											<div className="agent-image-bg" />

											<div className="agent-image-content-wrapper">
												<div className="agent-image-content">
													{agent.images.map(
														(image, idx) => (
															<img
																src={image.src}
																alt={
																	image.alt ||
																	"Agent Image"
																}
																className={
																	image.className
																}
																key={idx}
															/>
														)
													)}
												</div>
											</div>
										</div>

										<div className="agent-abilities">
											{/* Map through agent abilities */}
											{agent.abilities.map(
												(ability, idx) => (
													<div
														className="agent-ability-item"
														key={idx}
													>
														<div className="agent-ability-card">
															<div className="agent-ability-card-inner">
																<div className="ability-card-icon">
																	<img
																		src={
																			ability.icon
																		}
																		alt="Ability Icon"
																	/>
																</div>
																<div className="ability-card-content">
																	<h5 className="ability-card-title">
																		{
																			ability.title
																		}
																	</h5>

																	{/* Only show description if it exists */}
																	{ability.description && (
																		<p className="ability-card-desc">
																			{
																				ability.description
																			}
																		</p>
																	)}
																</div>
															</div>
														</div>
													</div>
												)
											)}
										</div>
									</div>
								</div>
							</React.Fragment>
						))}
					</div>
				</div>
			</div>
		</>
	);
}
